import domready from 'domready'
import MicroModal from 'micromodal'

import '../styles/modal.css'
import { addNativeEvent } from '../common/utils'
import { collectData, submitLead } from './bind_forms'
import modalTemplate from '../templates/modal.ejs'
import {airbrakeNotify} from '../common/airbrake'

export function prepareModal() {
  domready(() => {
    document.body.insertAdjacentHTML('beforeend', modalTemplate())

    document.querySelectorAll('.pop-jensen-modal').forEach(link => {
      addNativeEvent(link, 'click', onModalLinkClick)
    })

    addNativeEvent(document.getElementById('jensen_modal_form'), 'submit', (e) => {
      e.preventDefault()
      submitLead(
        collectData(e.target),
        () => {
          e.target.reset()
          MicroModal.close('modal-jensen')
        },
        (xhr) => { airbrakeNotify(`Jensen modal submit: ${this}: ${xhr.statusText}`) }
      )
      return false
    })
  })
}

function onModalLinkClick(e) {
  e.preventDefault()

  MicroModal.show('modal-jensen', {
    onShow: () => {
      document.getElementById('jensen_modal_form').querySelector('input').focus()
    }
  })
}



// WEBPACK FOOTER //
// ./app/js/modals.js